import InputField from "@_common/InputRuleFeild";
import { convertCurrentDateWithTime } from "@_common/date-helpers";
// import { handleDownloadOnClick } from "@_common/downloadfile";
import {
  concatDotToDocumentString,
  concatDotToString,
  getEncodedKey,
} from "@_common/text-helpers";
import { getValue } from "@utils/lodash";
import React, { useState } from "react";
import { getFirstLetter } from "@_common/format-text";
import DragAndDropFileComponent from "@_common/file-drag-drop";
import { downloadURL } from "@services/auth.service";
import { saveAs } from "file-saver";
import { sanitizeInput } from "@_common/dompurify";
import { canShowMarkCompleted } from "@_common/task-status";

function InternalComplianceUpdatePopup(props: any) {
  const {
    showUpdatePopup,
    setShowUpdatePopup,
    selfCompliance,
    setSelfCompliance,
    handleUploadDocuments,
    handleSubmitTask,
    submitLoading,
    selectedStatus,
    selectedObj,
    removeDocument,
    //upload
    handleDrop,
    uploadLoading,
    handleDragOver,
    disableUpload,
    selectedIDs,
  } = props;
  const [complianceStatusList] = useState([
    { value: "POSING", label: "Posing" },
    { value: "PENDING", label: "Pending" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NON_COMPLIED", label: "Non Complied" },
    { value: "DELAYED", label: "Delayed" },
    { value: "DELAYED_REPORTED", label: "Delay Reported" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "PENDING_FOR_APPROVAL", label: "Pending For Approval" },
    { value: "RE_OPENED", label: "Re Opened" },
    { value: "WORK_IN_PROGRESS", label: "Work In Progress" },
    { value: "PARTIALLY_COMPLIED", label: "Partially Complied" },
    { value: "ASSIGNED", label: "Assigned" },
  ]);

  // Complied
  const checkCompiled = () => {
    if (
      getValue(selectedIDs, "length", 0) > 1 &&
      getValue(props, "list.length", 0) > 0
    ) {
      const selectedTasks = props.list.filter((item: any) =>
        selectedIDs.includes(getValue(item, "id", ""))
      );
      if (selectedTasks.length > 0) {
        return selectedTasks.every((item: any) =>
          canShowMarkCompleted(getValue(item, "compliance_status", ""))
        );
      }
    }
    const status =
      getValue(selfCompliance, `compliance_status`, "") ||
      getValue(selectedObj, `compliance_status`, "");
    return canShowMarkCompleted(status);
  };
  // approved, Reopen
  const checkApprover = () => {
    return (getValue(selfCompliance, `compliance_status`, "") === "COMPLIED" ||
      getValue(selfCompliance, `compliance_status`, "") === "DELAYED" ||
      getValue(selfCompliance, `compliance_status`, "") ===
        "DELAYED_REPORTED") &&
      getValue(selectedObj, `approval_status`, "") === "PENDING"
      ? true
      : false;
  };
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState<any>(null);
  const handleDownloadOnClick = async (
    url: string,
    name: string,
    index: number
  ) => {
    try {
      setSelectedIndex(index);
      setIsLoading(true);
      let resp = await downloadURL(getEncodedKey(url));
      if (resp) {
        let url = getValue(resp, `data.url`, "")
        ? getValue(resp, `data.url`, "").includes("https://")
          ? getValue(resp, `data.url`, "")
          : `https://${getValue(resp, `data.url`, "")}`
        : getValue(resp, `data.url`, "");
        saveAs(url, name);
        setIsLoading(false);
        setSelectedIndex(null);
      } else {
        setIsLoading(false);
        setSelectedIndex(null);
      }
    } catch (error) {
      setIsLoading(false);
      setSelectedIndex(null);
    }
  };
  return (
    <div
      className={`compelte-task-wrapper ${
        showUpdatePopup ? "compelte-task-wrapper--active" : ""
      }`}
    >
      <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
        <h6 className="compelte-task-wrapper__title">{checkCompiled() ? "Complete Task" : "Task Info"}</h6>
        <img
          src="/images/close-white.svg"
          className="img-fluid navigation-bar-wrapper__close-btn"
          onClick={() => {
            setShowUpdatePopup(false);
          }}
        />
      </div>
      <div className="compelte-task-wrapper__body d-flex h-100">
        <div className="compelte-task-wrapper__completion compelte-task-wrapper__completion_fixed_button flex-2 padd-0">
          <div className="complete-task-wrapper__completion-holder">
            <div className="compelte-task-wrapper__common-header">
              <h5 className="compelte-task-wrapper__common-title">
                Task Completion
              </h5>
            </div>
            <div className="compelte-task-wrapper__form mt-0">
              <div className="compelte-task-wrapper__form-group mt-0 mb-0 d-flex align-items-center gap">
                <div className="form-group cursor-pointer grid mt-0 mb-0">
                  <div className="position-relative input-grid-item">
                    <label className="compelte-task-wrapper__label ms-0 fw-bold">
                      Completion Date
                    </label>
                    <label onClick={(e) => e.preventDefault()} className="ms-0">
                      <InputField
                        inputType="DATETYPE-DOB-MODAL"
                        value={getValue(selfCompliance, `completion_date`, "")}
                        className="form-control"
                        onChange={(e: any) =>
                          setSelfCompliance({
                            ...selfCompliance,
                            completion_date: e,
                          })
                        }
                        maxDate={new Date()}
                        placeholderText={"Enter Completion Date"}
                        disabled={checkApprover() ? true : false}
                      />
                      <img
                        src="/images/calander.svg"
                        className="img-fluid form-image form-image--calender-modal"
                      />
                    </label>
                  </div>
                </div>
                <div className="d-flex mt-3 gap position-relative">
                  <label>
                    <input
                      type="checkbox"
                      className="default-checkbox"
                      checked={getValue(
                        selfCompliance,
                        `event_not_occured`,
                        ""
                      )}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          event_not_occured: !getValue(
                            selfCompliance,
                            `event_not_occured`,
                            ""
                          ),
                        })
                      }
                    />
                    <div className="custom-checkbox">
                      <img
                        src="/images/uploaded-details/tick.svg"
                        className="upload-tick img-fluid"
                      />
                    </div>
                  </label>
                  <p>Event did not occur</p>
                </div>
              </div>
              {checkCompiled() && (
                <>
                  <div className="compelte-task-wrapper__form-group mt-0">
                    <label className="compelte-task-wrapper__label">
                      Remarks
                    </label>
                    <textarea
                      placeholder="Remarks"
                      className="w-100 compelte-task-wrapper__text-area"
                      rows={3}
                      value={getValue(selfCompliance, `remarks`, "")}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          remarks: sanitizeInput(e.target.value),
                        })
                      }
                    ></textarea>
                  </div>
                  <div className="compelte-task-wrapper__form-group">
                    <label className="compelte-task-wrapper__label">
                      Reason for Non-Compliance
                    </label>
                    <textarea
                      placeholder="Enter Reason for Non-Compliance"
                      className="w-100 compelte-task-wrapper__text-area"
                      rows={3}
                      value={getValue(
                        selfCompliance,
                        `non_compliance_reason`,
                        ""
                      )}
                      onChange={(e: any) =>
                        setSelfCompliance({
                          ...selfCompliance,
                          non_compliance_reason: sanitizeInput(e.target.value),
                        })
                      }
                    ></textarea>
                  </div>
                </>
              )}
              {checkApprover() && (
                <div className="compelte-task-wrapper__form-group">
                  <label className="compelte-task-wrapper__label">
                    Evaluator Comments
                  </label>
                  <textarea
                    placeholder="Enter Evaluator Comments"
                    className="w-100 compelte-task-wrapper__text-area"
                    rows={3}
                    value={getValue(selfCompliance, `evaluator_comments`, "")}
                    onChange={(e: any) =>
                      setSelfCompliance({
                        ...selfCompliance,
                        evaluator_comments: sanitizeInput(e.target.value),
                      })
                    }
                  ></textarea>
                </div>
              )}
              <div className="compelte-task-wrapper__form-group compelte-task-wrapper__label">
                <p className="mb-2">
                  Files Upload{" 	"}
                  {getValue(
                    selectedObj,
                    `self_compliance.document_required`,
                    ""
                  )
                    ? "*"
                    : ""}
                </p>
                <DragAndDropFileComponent
                  uploadFile={
                    !uploadLoading ? handleUploadDocuments : disableUpload
                  }
                  name="file"
                  multiple
                  // className="d-none"
                  classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                  fileName={getValue(props, `importedFile.name`, "")}
                  setImportTedFile={props.setImportTedFile}
                />
                {/* <div
                  onDrop={handleDrop}
                  onDragOver={!uploadLoading ? handleDragOver : disableUpload}
                >
                  <p>
                    Files Upload{" 	"}
                    {getValue(
                      selectedObj,
                      `self_compliance.document_required`,
                      ""
                    )
                      ? "*"
                      : ""}
                  </p>
                  <label className="custom-file-upload-popup">
                    {uploadLoading ? (
                      <p>Please wait...</p>
                    ) : (
                      <>
                        <p className="custom-inputfile__attach">
                          Drag & Drop Files here
                        </p>
                        <p className="custom-inputfile__attach">OR</p>
                        <a href="#0">
                          <p className="custom-inputfile__attach">Browse Files</p>
                        </a>
                      </>
                    )}
                    <input
                      type="file"
                      onChange={
                        !uploadLoading ? handleUploadDocuments : disableUpload
                      }
                      multiple
                      className="d-none"
                    />
                  </label>
                </div> */}
                <div className="compelte-task-wrapper__uploaded-files mt-2">
                  <ul>
                    {getValue(selfCompliance, `document_ids`, []).map(
                      (item: any, key: number) => {
                        return (
                          <li className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between cursor-pointer">
                            {selectedIndex === key && isLoading ? (
                              <>
                                <span>Downloading...</span>
                                <img
                                  src="/images/close-black.svg"
                                  onClick={() =>
                                    removeDocument(getValue(item, `id`, ""))
                                  }
                                />
                              </>
                            ) : (
                              <>
                                <span
                                  onClick={() =>
                                    !selectedIndex &&
                                    !isLoading &&
                                    handleDownloadOnClick(
                                      getValue(item, `url`, ""),
                                      getValue(item, `name`, ""),
                                      key
                                    )
                                  }
                                >
                                  {concatDotToDocumentString(
                                    getValue(item, `name`, "")
                                  )}
                                  {getValue(item, `extension`, "")}
                                </span>
                                <img
                                  src="/images/close-black.svg"
                                  onClick={() =>
                                    removeDocument(getValue(item, `id`, ""))
                                  }
                                />
                              </>
                            )}
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {getValue(props, `permissions`, []).includes("update") ? (
            <>
              {checkApprover() ? (
                <div className="compelte-task-wrapper__cta d-flex align-items-center">
                  <button
                    className="ascent-button ascent-button--primary"
                    onClick={() => handleSubmitTask("RE_OPENED")}
                    disabled={selectedStatus === "RE_OPENED" && submitLoading}
                  >
                    {selectedStatus === "RE_OPENED" && submitLoading
                      ? "Please wait..."
                      : "Reopen"}
                  </button>
                  <button
                    className="ascent-button ascent-button--secondary"
                    onClick={() => handleSubmitTask("APPROVED")}
                    disabled={selectedStatus === "APPROVED" && submitLoading}
                  >
                    {selectedStatus === "APPROVED" && submitLoading
                      ? "Please wait..."
                      : "Approve"}
                  </button>
                </div>
              ) : checkCompiled() ? (
                <div className="compelte-task-wrapper__cta d-flex align-items-center">
                  <button
                    className="ascent-button ascent-button--primary"
                    onClick={() => setShowUpdatePopup(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="ascent-button ascent-button--secondary"
                    onClick={() => handleSubmitTask("COMPLIED")}
                    disabled={submitLoading}
                  >
                    {submitLoading ? "Please wait..." : "Mark Completed"}
                  </button>
                </div>
              ) : null}
            </>
          ) : null}
        </div>
        <div className="compelte-task-wrapper__response flex-1">
          <div className="compelte-task-wrapper__common-header">
            <h5 className="compelte-task-wrapper__common-title">
              Task Responses
            </h5>
          </div>
          <div className="compelte-task-wrapper__form ">
            <div className="grid">
              <div className="compelte-task-wrapper__form-group input-grid-item">
                <InputField
                  inputType="INPUT_REACT_SELECT_MODAL"
                  placeholder="Enter Compliance Status"
                  className="form-control w-100"
                  name="compliance_status"
                  id="compliance_status"
                  value={complianceStatusList.filter(
                    (item: object) =>
                      getValue(item, `value`, "") ===
                      getValue(selfCompliance, `compliance_status`, "")
                  )}
                  options={complianceStatusList}
                  onChange={(e: any) =>
                    setSelfCompliance({
                      ...selfCompliance,
                      compliance_status: e.value,
                    })
                  }
                  label="Compliance Status"
                  disabled
                />
              </div>
            </div>

            {/* <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
              <h6>Legal Due Date : </h6>
              <p>{getValue(props, `selectedLegalDueDate`, "")}</p>
            </div> */}

            <div className="compelte-task-wrapper__form-group">
              {(checkApprover() ||
                getValue(props, `main_route`, "") === "approved-task") &&
                (getValue(selectedObj, `executor_completion_date`, "") ||
                  getValue(selectedObj, `remarks`, "")) && (
                  <div className="popup-margin-bottom">
                    <div className="circle">
                      <p className="text">
                        {getFirstLetter(
                          getValue(selectedObj, `executor.first_name`, "")
                        )}
                      </p>
                    </div>
                    <div className="mt-2">
                      <h6 className="compelte-task-wrapper__label_popup ">
                        Executor -{" "}
                        {getValue(selectedObj, `executor.first_name`, "") +
                          " " +
                          getValue(selectedObj, `executor.last_name`, "")}
                      </h6>
                      <p className="subtext_popup mb-3">
                        Updated on{" "}
                        {convertCurrentDateWithTime(
                          getValue(selectedObj, `executor_completion_date`, "")
                        )}
                      </p>
                      <p className="subtext-header mb-1">
                        {getValue(selectedObj, `remarks`, "")}
                      </p>
                    </div>
                  </div>
                )}
              {(checkCompiled() ||
                getValue(props, `main_route`, "") === "approved-task") &&
                (getValue(selectedObj, `evaluator_completion_date`, "") ||
                  getValue(selectedObj, `evaluator_comments`, "")) && (
                  <div className="popup-margin-bottom">
                    <div className="circle">
                      <p className="text">
                        {getFirstLetter(
                          getValue(selectedObj, `evaluator.first_name`, "")
                        )}
                      </p>
                    </div>
                    <div className="mt-2">
                      <h6 className="compelte-task-wrapper__label_popup ">
                        Evaluator -{" "}
                        {getValue(selectedObj, `evaluator.first_name`, "") +
                          " " +
                          getValue(selectedObj, `evaluator.last_name`, "")}
                      </h6>
                      <p className="subtext_popup mb-2">
                        Updated on{" "}
                        {convertCurrentDateWithTime(
                          getValue(selectedObj, `evaluator_completion_date`, "")
                        )}
                      </p>
                      <p className="subtext-header mb-1">
                        {getValue(selectedObj, `evaluator_comments`, "")}
                      </p>
                    </div>
                  </div>
                )}
              {(checkApprover() ||
                getValue(props, `main_route`, "") === "approved-task") && (
                <>
                  {/* {getValue(selfCompliance, `remarks`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label">
                          Remarks
                        </label>
                        <p>{getValue(selfCompliance, `remarks`, "")}</p>
                      </div>
                    </div>
                  )} */}
                  {getValue(selfCompliance, `non_compliance_reason`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-2">
                        <label className="compelte-task-wrapper__label">
                          Non Compliance Reason
                        </label>
                        <p className="subtext-header mb-1 mt-1">
                          {getValue(
                            selfCompliance,
                            `non_compliance_reason`,
                            ""
                          )}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
              {/* {(checkCompiled() ||
                getValue(props, `main_route`, "") === "approved-task") &&
                getValue(selectedObj, `evaluator_comments`, "") && (
                  <div className="popup-margin-bottom ">
                    <img
                      src="/images/comments.svg"
                      className="img-fluid"
                      style={{
                        height: "30px",
                        width: "30px",
                        marginRight: "10px",
                      }}
                    />
                    <div className="mt-2 mb-3">
                      <label className="compelte-task-wrapper__label">
                        Evaluator Comments
                      </label>
                      <p>{getValue(selectedObj, `evaluator_comments`, "")}</p>
                    </div>
                  </div>
                )} */}

              {
                <>
                  {getValue(selectedObj, `auditor_comments`, "") && (
                    <div className="popup-margin-bottom ">
                      <img
                        src="/images/comments.svg"
                        className="img-fluid"
                        style={{
                          height: "30px",
                          width: "30px",
                          marginRight: "10px",
                        }}
                      />
                      <div className="mt-2 mb-3">
                        <label className="compelte-task-wrapper__label_popup">
                          Auditor Comments
                        </label>
                        {getValue(selectedObj, `audit_completed_date`, "") && (
                          <p className="subtext_popup mb-2">
                            Updated on{" "}
                            {convertCurrentDateWithTime(
                              getValue(selectedObj, `audit_completed_date`, "")
                            )}
                          </p>
                        )}
                        <p className="subtext-header mb-1">
                          {getValue(selectedObj, `auditor_comments`, "")}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InternalComplianceUpdatePopup;
